import axios from 'axios';

const SESSION_TOKEN_KEY = 'cart_session_token';

function getSessionToken() {
  let token = localStorage.getItem(SESSION_TOKEN_KEY);
  if (!token) {
    token = crypto.randomUUID();
    localStorage.setItem(SESSION_TOKEN_KEY, token);
  }
  return token;
}

export const api = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}/api/storefront`,
  headers: {
    Accept: 'application/json',
  },
});

api.interceptors.request.use((config) => {
  config.headers['X-Cart-Session'] = getSessionToken();
  return config;
});
